module.exports = __webpack_public_path__ + "img/oriental.bd3398ef.png";